<template>
  <LoverShape />
  <LoverType />
  <Input
    v-if="hasElement(product, 'loverType', 'names')"
    :placeholder="defaultNames"
    id="names"
    classes="col-12"
    :label="$t('Names')"
    name="names"
    rules="required"
    :value="product.attributes.names"
    @updated-value="updatedInputField"
  />
  <Input
    v-if="hasElement(product, 'loverType', 'date')"
    :placeholder="defaultDate"
    id="date"
    classes="col-12"
    :label="$t('Date')"
    name="date"
    rules="required"
    :value="product.attributes.date"
    @updated-value="updatedInputField"
  />
  <Input
    v-if="hasElement(product, 'loverType', 'place')"
    :placeholder="defaultPlace"
    id="place"
    classes="col-12"
    :label="$t('Place')"
    name="place"
    rules="required"
    :value="product.attributes.place"
    @updated-value="updatedInputField"
  />
</template>
<script>
import { mapGetters } from "vuex";
import useProduct from "../../useProduct";
import useLover from "../../useLover";
import Input from "../Input";
import LoverType from "./LoverType";
import LoverShape from "./LoverShape";

export default {
  components: {
    Input,
    LoverType,
    LoverShape,
  },
  computed: {
    ...mapGetters({
      attributes: "product/getAttributes",
      product: "product/getProduct",
    }),
  },
  setup() {
    const { hasElement, defaultNames, defaultDate, defaultPlace } = useLover();
    const { updatedInputField } = useProduct();

    return {
      updatedInputField,
      hasElement,
      defaultNames,
      defaultDate,
      defaultPlace,
    };
  },
};
</script>
